export const create = {
  createSuccessfully: 'Create new tank successfully!',
  createFailed: 'Create new tank failed!',
}
